import { render, staticRenderFns } from "./secondary-btn.vue?vue&type=template&id=05515656&scoped=true&"
import script from "./secondary-btn.vue?vue&type=script&lang=js&"
export * from "./secondary-btn.vue?vue&type=script&lang=js&"
import style0 from "./secondary-btn.vue?vue&type=style&index=0&id=05515656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05515656",
  null
  
)

export default component.exports